import { Container, Icons, Presentation } from "./styles";

import { FiGithub } from "react-icons/fi";
import { FaWhatsapp, FaLinkedin } from "react-icons/fa";

//
export const Footer = () => {
  return (
    <Container>
      <Presentation>
        <p>
          Copyright 2023 ©<strong>Arthur Fortunato</strong>
        </p>
      </Presentation>
      <Icons>
        <a
          href="https://www.linkedin.com/in/arthur-fortunato-643828187/"
          target="_blank"
          rel="noreferrer"
        >
          <FaLinkedin size={"20px"} />
        </a>
        <a
          href="https://api.whatsapp.com/send?phone=5521999274461"
          target="_blank"
          rel="noreferrer"
        >
          <FaWhatsapp size={"20px"} />
        </a>
        <a
          href="https://github.com/arthurfortunato"
          target="_blank"
          rel="noreferrer"
        >
          <FiGithub size={"20px"} />
        </a>
      </Icons>
    </Container>
  );
};
